import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: none;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
` as typeof Link;

export default StyledLink;
